import React from 'react';
import './StravaAttribution.css';

interface StravaAttributionProps {
  theme?: 'light' | 'dark';
  size?: 'small' | 'medium';
  className?: string;
}

export const StravaAttribution: React.FC<StravaAttributionProps> = ({ 
  theme = 'light', 
  size = 'medium',
  className = ''
}) => {
  const logoSrc = theme === 'dark' 
    ? '/strava-assets/api_logo_pwrdBy_strava_horiz_white.png'
    : '/strava-assets/api_logo_pwrdBy_strava_horiz_black.png';

  return (
    <div className={`strava-attribution ${theme} ${size} ${className}`}>
      <img 
        src={logoSrc}
        alt="Powered by Strava"
        className="strava-attribution-logo"
      />
    </div>
  );
}; 